import { LocaleText } from '../AppProvider/LocalizationProvider';

export type CRUDLocaleText = Pick<
  LocaleText,
  | 'save'
  | 'editLabel'
  | 'createLabel'
  | 'deleteLabel'
  | 'editErrorMessage'
  | 'reloadButtonLabel'
  | 'deleteCancelLabel'
  | 'createErrorMessage'
  | 'editSuccessMessage'
  | 'deleteConfirmTitle'
  | 'deleteConfirmLabel'
  | 'deleteErrorMessage'
  | 'deletedItemMessage'
  | 'createNewButtonLabel'
  | 'createSuccessMessage'
  | 'deleteConfirmMessage'
  | 'deleteSuccessMessage'
>;

export const CRUD_DEFAULT_LOCALE_TEXT: CRUDLocaleText = {
  save: 'Save',
  editLabel: 'Edit',
  createLabel: 'Create',
  deleteLabel: 'Delete',
  deleteCancelLabel: 'Cancel',
  deleteConfirmLabel: 'Delete',
  reloadButtonLabel: 'Reload data',
  createNewButtonLabel: 'Create new',
  deleteConfirmTitle: 'Delete item?',
  editSuccessMessage: 'Item edited successfully.',
  editErrorMessage: 'Failed to edit item. Reason:',
  deletedItemMessage: 'This item has been deleted.',
  createSuccessMessage: 'Item created successfully.',
  deleteSuccessMessage: 'Item deleted successfully.',
  createErrorMessage: 'Failed to create item. Reason:',
  deleteErrorMessage: 'Failed to delete item. Reason:',
  deleteConfirmMessage: 'Do you wish to delete this item?',
};
